import React, { useState, useEffect } from 'react';
import './Branding.css';
import { useTranslation } from 'react-i18next';
import { upload_logo, get_branding } from '../../context/Services/Branding';
import swal from 'sweetalert';

const Branding = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [currentLogo, setCurrentLogo] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    // Fetch current logo on mount
    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const res = await get_branding('website_logo');
                if (res?.data) {
                    setCurrentLogo(res.data);
                }
            } catch (e) {
                console.log('No logo set yet');
            }
        };
        fetchLogo();
    }, []);

    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            // Create preview URL
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle upload
    const handleUpload = async () => {
        if (!selectedFile) {
            swal("Error", t("Please select a file first"), "error");
            return;
        }

        setLoading(true);
        try {
            const res = await upload_logo(selectedFile);
            if (res?.success) {
                setCurrentLogo(res.data.value);
                setSelectedFile(null);
                setPreviewUrl(null);
                swal("Success", t("Logo uploaded successfully"), "success");

                // Trigger a page reload to update all logo instances
                window.location.reload();
            }
        } catch (e) {
            console.log(e);
            swal("Error", t("Failed to upload logo"), "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="branding_container">
            <h3 className="branding_title">{t("Branding Settings")}</h3>
            <p className="branding_subtitle">{t("Customize your website appearance")}</p>

            <div className="branding_section">
                <h4>{t("Website Logo")}</h4>
                <p className="branding_hint">{t("Upload a logo for your website. It will appear in the navbar, sidebar, and login page.")}</p>

                <div className="logo_upload_area">
                    {/* Current Logo Preview */}
                    <div className="logo_preview_section">
                        <label>{t("Current Logo")}</label>
                        <div className="logo_preview_box">
                            {currentLogo ? (
                                <img src={currentLogo} alt="Current Logo" className="logo_preview_img" />
                            ) : (
                                <p className="no_logo_text">{t("No logo set")}</p>
                            )}
                        </div>
                    </div>

                    {/* New Logo Upload */}
                    <div className="logo_upload_section">
                        <label>{t("Upload New Logo")}</label>
                        <div className="logo_upload_box">
                            {previewUrl ? (
                                <img src={previewUrl} alt="Preview" className="logo_preview_img" />
                            ) : (
                                <div className="upload_placeholder">
                                    <p>{t("Click to select an image")}</p>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                className="file_input"
                            />
                        </div>
                        {selectedFile && (
                            <p className="file_name">{selectedFile.name}</p>
                        )}
                    </div>
                </div>

                <button
                    className="upload_button"
                    onClick={handleUpload}
                    disabled={loading || !selectedFile}
                >
                    {loading ? t("Uploading...") : t("Save Logo")}
                </button>
            </div>
        </div>
    );
};

export default Branding;
